var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_9047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "dollar-sign",
    d: "M14.0625 11.9712C14.0625 10.3944 13.0775 9.50375 10.7731 8.94875V6.17375C11.4856 6.32 12.1675 6.62687 12.8344 7.10875L13.6837 5.73625C12.8471 5.12346 11.8645 4.74074 10.8337 4.62625V3.75H9.515V4.59688C7.62 4.74312 6.33187 5.82375 6.33187 7.40062C6.33187 9.05062 7.3625 9.85375 9.57563 10.4087V13.2712C8.59 13.125 7.77187 12.6869 6.9075 12.015L5.9375 13.3438C6.9758 14.1431 8.21293 14.6432 9.515 14.79V16.25H10.8337V14.8044C12.7587 14.6438 14.0625 13.5775 14.0625 11.9712ZM9.575 8.64187C8.40812 8.30625 8.12062 7.91188 8.12062 7.29813C8.12062 6.65625 8.62063 6.145 9.57563 6.07188L9.575 8.64187ZM12.2738 12.0731C12.2738 12.7744 11.7281 13.2562 10.7731 13.3294V10.6862C11.9556 11.0225 12.2738 11.4163 12.2738 12.0738V12.0731Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_9047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.6dc09fbb44678d9165de88e7c9e80d30.svg";
export { ForwardRef as ReactComponent };